export const sparkOrange = "#fb4d2f"
export const lightGreen = "#b6cac3"
export const dark = "#141A1A"
